<template>
  <div style="font-family: Dosis, Helvetica, Arial, sans-serif; font-size: 20px;">
    <el-row>
      <el-col :lg="15">
        <el-row>
          <el-col :lg="24" :style="stylePrix">
            <strong v-if="post.financement_mensualites">
              {{ post.financement_mensualites }} {{ convertDevise(post.devise_iso_4217) }}/ {{ $t('general.month')}}<br>
              <div style="font-size: 20px;color: #000000;margin-top: -20px" v-if="post.financement_apport">{{ $t('posts.edit.financementApport') + ' : ' + post.financement_apport + ' ' + convertDevise(post.devise_iso_4217) }}</div>
            </strong>
            <strong v-else>
              {{ post.prixDisplay }}<br>
              <div style="font-size: 20px;color: #000000;margin-top: -20px">({{$t('posts.view.withoutLicenceAndFuelFees')}})</div>
            </strong>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;text-align: center;">
          <el-col :lg="7" class="badges">
            <img :src="require(`@/assets/Icon_km-01.png`)" width="100">
          </el-col>
          <el-col :lg="7">
            <img :src="require(`@/assets/Icon_energie-01.png`)" width="100">
          </el-col>
          <el-col :lg="7" style="padding-top: 20px">
            <img :src="require(`@/assets/boite-de-vitesse.png`)" width="75" style="margin-bottom: 20px">
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;text-align: center;">
          <el-col :lg="7">
            {{ $t('posts.view.power') }} : <br>
            <strong>
              {{ post.puissance_fiscale }} CV<br>
              {{ post.puissance_reelle }} Ch
            </strong>
          </el-col>
          <el-col :lg="7">
            {{ $t('posts.view.energy') }} : <br>
            <strong style="text-transform:capitalize">
              {{ post.energie }}
            </strong>
          </el-col>
          <el-col :lg="7">
            {{ $t('posts.view.transmission') }} : <br>
            <strong style="text-transform:capitalize">
              {{ post.boite_de_vitesse }}
            </strong>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;text-align: center">
          <el-col :lg="7">
            <img :src="require(`@/assets/Icon_garantie-01.png`)" width="100">
          </el-col>
          <el-col :lg="7" v-if="post.classe_critair">
            <img :src="require(`@/assets/CRIT_AIR_` + post.classe_critair + `.png`)" width="100"/>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px;text-align: center;">
          <el-col :lg="7">
            {{ $t('posts.view.commercialWarranty') }} : <br>
            <strong v-if="post.garantie">
              {{ post.garantie }} {{ $t('general.month')}}
            </strong>
            <strong v-else>
              {{ $t('posts.view.without') }}
            </strong>
          </el-col>
          <el-col :lg="7" v-if="post.classe_critair">
            {{ $t('posts.view.vignette') }} :<br>
            <strong>Crit'air {{post.classe_critair}}</strong>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="9">
        <el-row style="margin-top: 30px">
          <el-col :lg="24">
            <el-image v-if="post.photoPrincipale != null"
                      :src="post.photoPrincipale.url" fit="contain">
            </el-image>
            <div class="text-center" v-else>
              <ubi-icon class="no-photo" name="camera" size='250'/>
            </div>
          </el-col>
        </el-row>
        <el-row v-if="post.numero_immatriculation">
          <el-col>{{ $t('posts.view.licencePlate') }} : {{ post.numero_immatriculation }}</el-col>
        </el-row>
        <el-row v-if="post.mise_en_circulation">
          <el-col>{{ $t('posts.view.miseEnCirculation') }} : <strong>{{post.mise_en_circulation}}</strong></el-col>
        </el-row>
        <el-row>
          <el-col v-if="post.kilometrage">{{$labels.kilometrage}} : <strong>{{post.kilometrage}} km</strong></el-col>
        </el-row>
        <el-row>
          <el-col v-if="post.poids">{{$t('posts.view.weightOfVehicle')}} : <strong>{{post.poids}} kg</strong></el-col>
        </el-row>
      </el-col>
    </el-row>

    <el-row style="border: solid;
        margin-top: 15px;
        border-color: #00b4cc;
        border-width: 1px;
        font-size: 30px;
        height:50px;
        overflow: hidden;
        text-align: center">
      <el-col :lg="24">
        <strong>{{post.titre}}</strong>
      </el-col>
    </el-row>

    <el-row>
      <el-col :lg="24" style="color:#0ab1bf; margin-top: 10px">
        <strong>{{ $t('posts.view.equipmentsAndOptions') }}</strong>
      </el-col>
    </el-row>
    <el-row style="border: solid;
        border-color: #00b4cc;
        border-width: 1px;
        font-size: 20px;
        text-align: center;
        height: 250px;
        overflow: hidden;
        ">
      <el-col :lg="24">
        {{convertText()}}
      </el-col>
    </el-row>

    <el-row style="margin-top: 15px; font-size: 12px">
      <el-col :lg="24" style="text-align: center">
        {{sitimmoUser.raisonSociale}}<br>
        {{sitimmoUser.adresse}} - {{sitimmoUser.codePostal}} {{sitimmoUser.ville}}<br>
        Tel. : {{sitimmoUser.telephone}}<br>
        Mail : {{sitimmoUser.email}}<br>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { deviseSimple } from '@/services/toolbox'

export default {
  name: 'PostPdfVo',
  props: ['post', 'sitimmoUser', 'universe'],
  data () {
    return {
      stylePrix: 'color:#0ab1bf;font-size: 100px;'
    }
  },
  methods: {
    convertDevise (devise) {
      return deviseSimple(devise)
    },
    convertText () {
      const text = this.post.equipments + '. ' + this.post.texte
      return text.substring(0, 1000)
    }
  },
  beforeMount () {
    if (this.post.financement_mensualites) {
      this.stylePrix = 'color:#0ab1bf;font-size: 72px;'
    }
  }
}
</script>

<style>

</style>
